import React                from 'react';
import PropTypes            from 'prop-types';
import ReactDOM             from 'react-dom';
import {
    Container,
    Wrapper,
    Icon,
    Value,
    Label,
    Arrow,
    ListContainer,
    List,
    Helper,
    Spinner
}                           from '../../uikit/dropdown/components'; 
import UiKit                from '../../uikit';

 export class Dropdown extends React.Component {
    constructor(props) {
        super(props);
        this.state = { 
            selectedOptions : null,
            selectedIndex   : null,
            isOpened        : false,
            menuPosition    : 'bottom',
            placeholderText : '',
            errors          : props.errors,
            scrollTop       : undefined,
            fromClient      : false,
            searchValue     : ''
        };

        this.handleBlur         = this.handleBlur.bind(this);
        this.handleKeys         = this.handleKeys.bind(this);
        this.containerRef       = React.createRef();
    }

    componentDidMount() {
        if (typeof window !== 'undefined') {
            window.addEventListener('keydown', this.handleKeys, false);
        }
        if (typeof window !== 'undefined') {
            window.addEventListener('click', this.handleBlur, false);
        }
        this.checkAutoFocus();
        this.selectInitialValue();
        this.setState({ fromClient: true });
    }

    componentWillUnmount() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('click', this.handleBlur, false);
            window.removeEventListener('keydown', this.handleKeys, false);
        }
    }

    componentDidUpdate(prevProps, _prevState) {
        this.checkErrorChanges(prevProps);
        this.checkOptionTranslationChanges(prevProps);
        this.checkNewOptionsAndDeselect(prevProps);
        this.checkNewValueAndSelect(prevProps);
    }

    checkErrorChanges(prevProps) {
        let p = this.props;
        if(prevProps.errors !== p.errors) {
            this.setState({ 
                errors       : p.errors
            });
        }
    }

    checkOptionTranslationChanges(prevProps) {
        const p = this.props;
        const s = this.state;
        if (JSON.stringify(prevProps.options) !== JSON.stringify(p.options)) {
            let currentSelections = [].concat(s.selectedOptions);
                currentSelections = currentSelections.map(selection => {
                    let item = p.options.find(option => selection && option && option.value === selection.value)
                    if (item)
                        selection.text = item.text;
    
                    return selection
                });
                this.setState({
                    selectedOptions: currentSelections
                });
        }
    }

    checkNewValueAndSelect(prevProps) {
        let p = this.props;
        if(prevProps.value !== p.value) {
            if(!p.isMultiple) {
                let option = p.options.find( o => o.value === p.value);
                if(option) {
                    let index = this.props.options.indexOf(option);
                    this.selectOption(option, index, p.changeOnAutoSelect);
                } else {
                    this.deselectOption(false, true);
                }
            } else {
                if(p.value)
                    this.selectMultipleValue();
            }
        }
    }

    selectMultipleValue() {
        let p = this.props;
        let options = p.options.filter( o => p.value.find(val => o.value === val));
        if(options) {
            this.setState({ 
                selectedOptions : options,
                placeholderText : options.map( s => s[p.shownValue] ).join(', '),
            }, () => {
                this.setSelectedOptionPositionToTop();
            });
        }
    }

    checkNewOptionsAndDeselect(prevProps) {
        let p = this.props;
        let s = this.state;
        let option = null;
        if(p.isMultiple) {
            option = p.value
                        ? s.selectedOptions
                            ? s.selectedOptions.filter( so => p.value.find( val => val === so.value))
                            : null
                        : s.selectedOptions
                            ? p.options.find( o => s.selectedOptions.find( so => so.value === o.value ))
                            : null;
        } else {
            option = p.value
                        ? p.options.find( o => o.value === p.value)
                        : s.selectedOptions
                            ? p.options.find( o => o.value === s.selectedOptions.value)
                            : null;
        }

        if(!option && JSON.stringify(this.props.options) !== JSON.stringify(prevProps.options)) {
            this.deselectOption(false, p.changeOnAutoSelect);
        } else if(option && JSON.stringify(this.props.options) !== JSON.stringify(prevProps.options)) {
            this.selectInitialValue();
        }
    }

    isInteractive() { return !this.props.isDisabled && !this.props.isLoading; }

    selectInitialValue() {
        let p = this.props;
        let index;
        if(p.isMultiple) {
            if(p.value) {
                this.selectMultipleValue();
            }
        } else {
            if(p.value) {
                let option = p.options.find( o => o.value === p.value);
                if(option && !this.state.selectedOptions) {
                    index = p.options.indexOf(option);
                    this.selectOption(option, index, p.changeOnAutoSelect);
                }
            }
        }
    }
 // TO DO burası defaultvalue için fgerekli ve daha sonra yapılacak
    /*
        selectInitialValue() {
            let p = this.props;
            let index;
            if(p.isMultiple) {
                if(p.value) {
                    this.selectMultipleValue();
                }
            } else {
                if(p.defaultValue) {
                    let option = p.options.find( o => o.value === p.defaultValue);
                    if(option && !this.selectedOptions) {
                        index = p.options.indexOf(option);
                        this.selectOption(option, index);
                    }
                }
            }
        }
    */

    checkAutoFocus() {
        let { autoFocus } = this.props;
        if(autoFocus) this.refs.VALUE.refs.CONTAINER.focus();
    }

    createComponentClasses() {
        let {
            colorType,
            required,
            hideRequiredStar,
            className,
            fullyColored,
            full
        } = this.props;
        let {
            errors
        } = this.state;

        let classNames = [];
        if (required && !hideRequiredStar)  classNames.push('required');
        if (fullyColored)                   classNames.push('fully-colored');
        if (errors)                         classNames.push('danger')
        if (!errors && colorType)           classNames.push(colorType);
        if (full)                           classNames.push('full');
        if (className)                      Array.prototype.push.apply(classNames, className.split(' '));

        return [...new Set(classNames)].join(' ');
    }

    handleBlur(e) {
        const p = this.props;
        const s = this.state;
        e.stopPropagation();
        const containerRef = this.containerRef && this.containerRef.current;
        if (containerRef && ReactDOM.findDOMNode(containerRef).contains(e.target)) {
            return;
        }
        if(s.isOpened) {
            this.checkValidity()
            this.setState({
                isOpened: false,
                selectedIndex: null,
                searchValue: '',
                scrollTop       : 0
            },
                () => {
                    if(typeof p.onBlur === 'function')
                        p.onBlur(s.selectedOptions);       
                }
            );
        }
    }

    calculateMenuPosition() {
        let s                       = this.state;
        let p                       = this.props;
        let dropdown                = this.refs.DROPDOWN_WRAPPER.refs.DROPDOWN_WRAPPER_INPUT;
        let optionsHeight           = p.options.length * 47;
        let dropdownMenuHeight      = optionsHeight > 220 ? 220 : optionsHeight; 
        let windowHeight            = window.innerHeight;
        let dropdownBoundingRect    = dropdown.getBoundingClientRect();

        if(!s.isOpened && (dropdownBoundingRect.top + dropdown.offsetHeight + dropdownMenuHeight) > windowHeight)
            return 'top';

        return 'bottom';
    }
    
    openDropdown() {
        let p  = this.props;
        let s  = this.state;
        if(this.isInteractive()) {
            this.setState({ 
                isOpened        : true,
                menuPosition    : this.calculateMenuPosition(),
                errors          : null,
            }, () => {
                this.setSelectedOptionPositionToTop();
                if(typeof p.onFocus === 'function')
                    p.onFocus(s.selectedOptions);
            });
        }
    }

    closeDropdown() {
        let p = this.props;
        let s = this.state;
        setTimeout( () => {
            this.setState({ 
                isOpened: false, 
                selectedIndex: null,
                searchValue: ''
            }, () => {
                if(typeof p.onBlur === 'function')
                    p.onBlur(s.selectedOptions);                
            });
        }, 100);
    }

    toggleDropdown(e) {
        let p = this.props;
        let s = this.state;
        if(this.isInteractive()) {
            this.setState({
                isOpened                : !s.isOpened,
                menuPosition            : this.calculateMenuPosition(),
                scrollTop               : 0
            }, () => {
                if(!s.isOpened) {
                    this.setSelectedOptionPositionToTop();
                    if(typeof p.onFocus === 'function')
                        p.onFocus(s.selectedOptions);
                } else {
                    if(typeof p.onBlur === 'function')
                        p.onFocus(s.selectedOptions); 
                }
            });
        }
    }

    setSelectedOptionPositionToTop() {
        let s                   = this.state;
        let opt                 = s.selectedOptions;
        //let dropdown            = this.refs.DROPDOWN.refs.CONTAINER;
        let targetOptionValue   = opt
                                    ?  Array.isArray(opt) 
                                        ? opt.length > 0 
                                            ? opt[0].value
                                            : null
                                        : opt.value
                                    : null;
        if(targetOptionValue) {
            let targetOption = document.querySelector('[data-value="' + targetOptionValue + '"]');
            if(targetOption) {
                //dropdown.scrollTo(0, (parseInt(targetOption.dataset.order)) * 44);
                this.changeSelectedIndex(targetOption.dataset.order);
                this.setState({
                    scrollTop       : (parseInt(targetOption.dataset.order)) * 44
                })
            }
        } else {
            this.setState({
                scrollTop       : undefined
            })
        }
    }

    createIconComponent() {
        let p = this.props;
        let s = this.state;
        if(p.icon)
            return (
                <Icon 
                    icon            = { p.icon }
                    isOpened        = { s.isOpened }
                    isDisabled      = { p.isDisabled }
                />
            );

        return null;   
    }

    createMultipleSelection(value) {
        let p           = this.props;
        let s           = this.state;
        let isMultiple  = p.isMultiple;
        if(isMultiple) {
            return <div className={ `multiple-select-check${Array.isArray(s.selectedOptions) && this.checkSelected(value) ? ' checked' : ''}`}></div>
        }
    }

    checkSelected(value) {
        let s = this.state;
        let selectedOptions = Array.isArray(s.selectedOptions) 
                                ? s.selectedOptions.find(o => o.value === value) 
                                : s.selectedOptions && s.selectedOptions.value === value;
        return !!selectedOptions;
    }

    deselectOption(validate, changeOnAutoSelect) {
        let p = this.props;
        let isMultiple  = p.isMultiple;
        this.setState({ 
            selectedOptions : p.isMultiple ? [] : null,
            isOpened        : false,
            placeholderText : p.placeholder
        }, () => {
            if(validate)
                this.checkValidity();

            if(typeof p.onChange === 'function' && changeOnAutoSelect)
                p.onChange(isMultiple ? [] : { text: '', value: null });
        });
    }

    selectOption(option, index, changeOnAutoSelect) {
        let p           = this.props;
        let s           = this.state;
        let isMultiple  = p.isMultiple;
        let optionList  = p.options;

        if(p.isSearchable && s.searchValue) {
            optionList = this.filteredOptions(optionList);
        }

        this.setState({
            errors: null
        })

        if(!option) return this.deselectOption(true, true);
        
        if(!isMultiple) {
            this.setState({
                selectedOptions : option,
                placeholderText : option[p.shownValue],
                isOpened        : false,
                searchValue     : ''
            }, () => {
                this.checkValidity();
                this.setSelectedOptionPositionToTop();
                if(typeof p.onChange === 'function' && changeOnAutoSelect) {
                    p.onChange(option);
                }
            });
        } else {
            let selectedOptions = Array.isArray(s.selectedOptions) ? [ ...s.selectedOptions ] : [];
            if(this.checkSelected(optionList[index].value)) {
                selectedOptions = selectedOptions.filter(o => o.value !== optionList[index].value);
            } else {
                selectedOptions.push(optionList[index]);
            }

            let newSelectedOptions = optionList.filter( o => selectedOptions.find( so => so.value === o.value));

            this.setState({ 
                selectedOptions : newSelectedOptions,
                placeholderText : selectedOptions.map( sOption => sOption[p.shownValue] ).join(', '),
            }, () => {
                this.checkValidity()
                if(typeof p.onChange === 'function' && changeOnAutoSelect) {
                    p.onChange(selectedOptions);
                }
            });
        }
    }

    selectAll() {
        let p           = this.props;
        let s           = this.state;

        let optionList  = p.options;
        
        if(p.isSearchable && s.searchValue) {
            optionList = this.filteredOptions(optionList)
        }

        let selectedOptions = Array.isArray(s.selectedOptions) ? [ ...s.selectedOptions ] : [];
        let newSelectedOptionList = [];

        if(selectedOptions.length <= optionList.length - 1) {
            newSelectedOptionList = optionList;
        }

        this.setState({ 
            selectedOptions: newSelectedOptionList,
            placeholderText : newSelectedOptionList.map( sOption => sOption[p.shownValue] ).join(', '),
        }, () => {
            this.checkValidity()
            if(typeof p.onChange === 'function')
                if(p.isRequired) {
                    if(newSelectedOptionList.length > 0) {
                        return p.onChange(newSelectedOptionList);
                    }
                    return;
                }   
            p.onChange(newSelectedOptionList);
        });


    }

    changeSelectedIndex(index) {
        let s = this.state;
        if(s.selectedIndex !== index)
            this.setState({ selectedIndex: index });
    }

    handleKeys(e) {
        const p                 = this.props;
        const s                 = this.state;
        const key               = e.keyCode || e.which;
        let optionList          = p.options;
        let nextIndex, currentIndex;

        if(p.isSearchable && s.searchValue) {
            optionList = this.filteredOptions(optionList)
        }

        if((s.isOpened) && (key === 38 || key === 40 || key === 27 || key === 13)) {
            e.stopPropagation();
            e.preventDefault();
            currentIndex = s.selectedIndex !== null ? s.selectedIndex : -1;

            if(key === 27) return this.closeDropdown();

            if(key === 13) {
                let option = currentIndex !== 0 
                                ? optionList[currentIndex - 1]
                                : null;
                return this.selectOption(option, currentIndex - 1, true);
            }

            if(key === 38) {
                nextIndex = currentIndex > 0
                                ? currentIndex - 1
                                : 0;
            }

            if(key === 40) {
                nextIndex = currentIndex < optionList.length
                                ? currentIndex + 1
                                : optionList.length
            }
            this.changeSelectedIndex(nextIndex);
            this.setState({ scrollTop: parseInt(nextIndex) * 47 });
            /* let dropdown = this.refs.DROPDOWN.refs.CONTAINER;
            dropdown.scrollTo(0, (parseInt(nextIndex)) * 44);  */     
            
            return false;
        }
    }

    onSearch(keyword) {
        this.setState({
            searchValue: keyword.trim(),
        })
    }

    filteredOptions(optionList) {
        const p = this.props;
        const s = this.state;

        return p.searchBy.reduce((acc, key) => {
            let filteredList = optionList.filter(option => option[key].toLocaleUpperCase('tr-TR').includes(s.searchValue.toLocaleUpperCase('tr-TR')));
            return [ ...new Set(acc.concat(filteredList)) ]
        }, [])
    }

    createOptionlist() {
        let p               = this.props;
        let s               = this.state;
        let options         = [];
        let optionList      = p.options;
        let isRequired      = p.required;
        let selectedOptions = Array.isArray(s.selectedOptions) ? [ ...s.selectedOptions ] : [];

        if(!isRequired) {
            options.push(
                <li
                    key         = { 0 }
                    data-value  = { null }
                    data-order  = { 0 }
                    onClick     = { () => this.deselectOption(true, true) }
                    onMouseOver = { () => this.changeSelectedIndex(0) }
                    className   = { `${s.selectedIndex === 0 ? 'hovered': ''}`}
                >
                    <span>...</span>
                </li>
            )
        }

        if(p.withSelectAll && p.isMultiple) {
            options.push(
                <li
                    key         = { 0 }
                    data-value  = { null }
                    data-order  = { 0 }
                    onClick     = { () => this.selectAll() }
                    onMouseOver = { () => this.changeSelectedIndex(0) }
                    className   = { `${!isRequired ? s.selectedIndex === 1 ? 'hovered': '' : s.selectedIndex === 0 ? 'hovered': ''}`}
                >
                    <div className={ `multiple-select-check${selectedOptions.length < optionList.length ? '' : ' checked'}`}></div>
                    <span>{ selectedOptions.length < optionList.length ? 'Select all...' : 'Deselect all...' }</span>
                </li>
            )
        }
            
        if(p.isSearchable && s.searchValue) {
            optionList = this.filteredOptions(optionList);
        }

        if(p.isSorted) {
            optionList.sort((e1, e2) => {
                return e1.text.localeCompare(e2.text);
            });
        }

        optionList.map( (o, i) => {
            let t = o.text !== null && o.text !== undefined 
                        ? o.text 
                        : '';
            options.push(
                <li
                    key         = { i + 1 }
                    data-value  = { o.value }
                    data-order  = { i + 1 }
                    onClick     = { () => this.selectOption(o, i, true) }
                    onMouseOver = { () => this.changeSelectedIndex(i + 1) }
                    className   = { `${o.value && this.checkSelected(o.value) ? 'selected': ''}${s.selectedIndex === i + 1 ? ' hovered': ''}`}
                >
                    { this.createMultipleSelection(o.value) }
                    <span>{ t }</span>
                    { this.createOptionHelper(o) }
                </li>
            )
        });
        return s.fromClient
            ? options
            : null;
    }

    createOptionHelper(option) {
        return option.helper
                    ?   <div className="option-helper">
                            { 
                                option.helper.icon
                                    ?   <UiKit.Icon 
                                            colorType   = { option.helper.colorType || `simpra-gray` } 
                                            icon        = { option.helper.icon } 
                                            size        = "sml" 
                                        />
                                    :   null
                            }
                            {
                                option.helper.text || null
                            }
                        </div>
                    :   null;
    }

    getSelectedValues() {
        let s = this.state;
        let selectedOptions = s.selectedOptions;
        if(selectedOptions) {
            if(Array.isArray(selectedOptions)) {
                return selectedOptions.map( o => o.value ).join(',');
            } else {
                return selectedOptions.value;
            }
        }
        return '';
    }

    checkValidity() {
        let { 
            required,
        } = this.props;
        let errors = [];
        let { validity } = this.refs.VALUE.refs.CONTAINER;

        // Don't validate if is isDisabled or isLoading
        if(!this.isInteractive()) return;
        
        // If valid, return null
        if(validity.valid) return;
        
        // If field is required and empty
        if(required && validity.valueMissing) 
            errors.push({ type: 'required', message: 'Please fill out this field.' });

        if(errors.length > 0)
            this.setState({
                errors,
            });
    }

    render() {
        let p = this.props;
        let s = this.state;
        let options = this.createOptionlist();
        return (
            p.isVisible
                ?   <Container 
                        isOpened        = { s.isOpened }
                        menuPosition    = { s.menuPosition }
                        isDisabled      = { p.isDisabled } 
                        ref             = { this.containerRef }
                        className       = { this.createComponentClasses() }
                        onMouseOut      = { () => this.changeSelectedIndex(null) }
                    >
                        <Label>{ p.label }</Label>
                        <Wrapper
                            ref     = "DROPDOWN_WRAPPER"
                            onClick = { e => this.toggleDropdown(e) }
                        >
                            { this.createIconComponent() }
                            <Value 
                                text            = { s.placeholderText }
                                placeholder     = { p.placeholder } 
                                openDropdown    = { () => this.openDropdown() } 
                                closeDropdown   = { () => this.closeDropdown() } 
                                selectedValue   = { this.getSelectedValues() }
                                ref             = 'VALUE'
                                required        = { p.required }
                                attrs           = { p.attrs }
                            />
                            {
                                !p.isLoading
                                    ? <Arrow isOpened={ s.isOpened } />
                                    : <Spinner />
                            }
                        </Wrapper>
                        <ListContainer 
                            isOpened     = { s.isOpened }
                            scrollTop    = { s.scrollTop } 
                            optionCount  = { options ? options.length : 0 }
                            isSearchable = { p.isSearchable }
                            searchValue  = { s.searchValue }
                            onSearch     = { keyword => this.onSearch(keyword) }
                            ref          = "DROPDOWN"
                        >
                            <List ref="DROPDOWN_MENU">
                                { options }
                            </List>
                        </ListContainer>
                        <Helper 
                            isDisabled          = { p.isDisabled }
                            text                = { s.errors ? s.errors[0].message : p.helper } 
                        />
                    </Container>
                :   null
        )
    }
}

Dropdown.propTypes = {
    label               : PropTypes.string,
    placeholder         : PropTypes.string,
    helper              : PropTypes.oneOfType([ PropTypes.string, PropTypes.array ]),
    isDisabled          : PropTypes.bool,
    isLoading           : PropTypes.bool,
    isVisible           : PropTypes.bool,
    isSorted            : PropTypes.bool,
    isSearchable        : PropTypes.bool,
    searchBy            : PropTypes.array,
    changeOnAutoSelect  : PropTypes.bool,
    required            : PropTypes.bool,
    fullyColored        : PropTypes.bool,
    attrs               : PropTypes.object,
    autoFocus           : PropTypes.bool,
    withSelectAll       : PropTypes.bool,
    icon                : PropTypes.string,
    className           : PropTypes.string,
    full                : PropTypes.bool,
    onChange            : PropTypes.func,
    onBlur              : PropTypes.func,
    onFocus             : PropTypes.func,
    hideRequiredStar    : PropTypes.bool,
    options             : PropTypes.arrayOf(
        PropTypes.shape({
            text        : PropTypes.any,
            value       : PropTypes.any
        }).isRequired
    ).isRequired,
    shownValue          : PropTypes.string,
    value               : PropTypes.oneOfType([ PropTypes.string, PropTypes.number, PropTypes.object, PropTypes.array, PropTypes.bool ]),
};

Dropdown.defaultProps = {
    label               : '',
    full                : false,
    helper              : '',
    placeholder         : 'Select',
    changeOnAutoSelect  : true,
    required            : false,
    fullyColored        : false,
    isSorted            : false,
    isSearchable        : false,
    searchBy            : [ 'text', 'value' ],
    isDisabled          : false,
    isLoading           : false,
    isVisible           : true,
    autoFocus           : false,
    withSelectAll       : false,
    size                : '',
    border              : '',
    icon                : '',
    colorType           : '',
    options             : [],
    className           : '',
    attrs               : {},
    onChange            : () => {},
    onFocus             : () => {},
    onBlur              : () => {},
    hideRequiredStar    : false,
    shownValue          : 'text',
    value               : ''
};

export default Dropdown;